export const Currencies = {
  EU: {
    unit: "€",
    type: "eur",
  },
};
